<template>
  <v-card
    ripple
    raised
    class="recipe-list-item secondary my-3"
    :to="{ name: 'recipes-detail', params: { url: recipe.url } }"
  >
    <v-layout>
      <v-img
        v-if="image"
        class="image"
        :lazy-src="imageLazy"
        :src="image"
      ></v-img>
      <recipe-image-placeholder v-else class="image" />
      <v-layout column>
        <v-flex class="px-2 py-2 primary--text title">
          <text-highlighted :search="query" :text="recipe.heading" />
        </v-flex>
        <v-flex class="px-2">
          <recipe-label
            :value="recipe.portions"
            icon="fa fa-utensils"
            v-if="recipe.portions"
          />
          <recipe-label-time
            :prepare="recipe.prepareTime"
            :cooking="recipe.totalTime"
          />
          <recipe-label-difficulty :difficulty="recipe.difficulty" />
        </v-flex>
        <v-flex>
          <v-layout>
            <v-flex class="px-2">
              <recipe-tag
                v-for="(tag, index) in recipe.tags"
                :key="index"
                :value="tag"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import RecipeLabel from "./RecipeLabel";
import RecipeLabelTime from "./RecipeLabelTime";
import RecipeLabelDifficulty from "./RecipeLabelDifficulty";
import RecipeTag from "@/components/RecipeTag";
import RecipeImagePlaceholder from "@/components/RecipeImagePlaceholder";
import {
  IMAGE_SIZE_LAZY,
  IMAGE_SIZE_SMALL,
  recipeImageUrl
} from "@/utils/ImageUtils";
import TextHighlighted from "@/components/TextHighlighted";

export default {
  name: "RecipeListItem",
  components: {
    TextHighlighted,
    RecipeImagePlaceholder,
    RecipeTag,
    RecipeLabelDifficulty,
    RecipeLabelTime,
    RecipeLabel
  },
  props: {
    recipe: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      return recipeImageUrl(this.recipe, IMAGE_SIZE_SMALL);
    },
    imageLazy() {
      return recipeImageUrl(this.recipe, IMAGE_SIZE_LAZY);
    },
    query() {
      return this.$store.state.filter.query;
    }
  }
};
</script>

<style scoped>
.recipe-list-item .title {
  font-weight: 300;
  font-size: 1.5rem;
}

.recipe-list-item .image {
  flex: 0 0 auto;
  min-height: 7rem;
  width: 7rem;
  background-size: cover;
  background-position: center center;
}
</style>
